export default __webpack_public_path__ + "static/developers-photo-eb7d7aa007a08b2c7bc78110da432305.webp";